import { render, staticRenderFns } from "./SignInButton.vue?vue&type=template&id=5105c0cb&lang=pug&"
import script from "./SignInButton.vue?vue&type=script&lang=js&"
export * from "./SignInButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SignInButton.vue"
export default component.exports